import Component from '../inherited/Component';

export default class DeliveryDate extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx);
    }

    mount() {
        let date = new Date();
        let hours = date.getHours();
        let day = date.getDay();
        const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];

        if (day != 6) {
            if (hours < 16) {
                date.setDate(date.getDate() + 1);
                this._elem.innerHTML = `${
                    weekday[date.getDay()]
                }, ${date.getDate()} ${monthNames[date.getMonth()]}`;
            } else {
                date.setDate(date.getDate() + 2);
                this._elem.innerHTML = `${
                    weekday[date.getDay()]
                }, ${date.getDate()} ${monthNames[date.getMonth()]}`;
            }
        } else {
            date.setDate(date.getDate() + 2);
            this._elem.innerHTML = `${
                weekday[date.getDay()]
            }, ${date.getDate()} ${monthNames[date.getMonth()]}`;
        }
    }
}
